import styled, { css } from 'styled-components'

export const StyledButton = styled.button`
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.44px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    background: ${({ theme }) => theme.veryLightPink};
    border: none;
    padding: 10px;
    margin-bottom: 10px;
    margin-left: 2.5px;
    margin-right: 2.5px;
    border-radius: 4px;
    cursor: pointer;
    height: 45px;
    ${({ big }) =>
        big &&
        css`
            height: 55px;
        `} 
    ${({ green }) =>
        green &&
        css`
        color: ${({ theme }) => theme.whiteTwo};
        background: ${({ theme }) => theme.grassyGreen};
    `};
    ${({ red }) =>
        red &&
        css`
        color: ${({ theme }) => theme.whiteTwo};
        background: ${({ theme }) => theme.pastelRed};
    `};

    ${({ transparent }) =>
        transparent &&
        css`
        background: transparent;
    `};

    ${({ transparentGreen }) =>
        transparentGreen &&
        css`
        color: ${({ theme }) => theme.greyishBrown};
        background: transparent;
        border: 2px solid ${({ theme }) => theme.grassyGreen};
    `};

    ${({ transparentGrey }) =>
        transparentGrey &&
        css`
        color: ${({ theme }) => theme.brownGrey};
        font-weight: ${({ theme }) => theme.fontWeight.regular};
        background: transparent;
        border: 1px solid ${({ theme }) => theme.brownGrey};
    `};

    ${({ transparent, green }) =>
        (transparent && green) &&
        css`
        color: ${({ theme }) => theme.grassyGreen};
        background: transparent;
    `};

    ${({ fullWidth }) =>
        fullWidth &&
        css`
        width: calc(100% - 5px);
    `};
    ${({ width }) =>
        width &&
        css`
            width: ${({ width }) => `calc(${width} - 5px)`};
    `};
    ${({ noMargin }) =>
        noMargin &&
        css`
            margin: 0;
    `};
    ${({ noPadding }) =>
        noPadding &&
        css`
            padding: 0;
    `};
    ${({ noRadius }) =>
        noRadius &&
        css`
            border-radius: 0;
    `};
    ${({ disabled }) =>
        disabled &&
        css`
            pointer-events: none;
            opacity: 0.5;
    `};
`